export default __webpack_public_path__ + "static/media/icon-warning-white.bd91892d.svg";